import { Injectable } from '@angular/core';
import { FetchDataService } from '@vex/http-service/fetch-data.service';
import { CollectionEntryService } from '@vex/http-service/collection-entry.service';
import { ValueFrom } from '@vex/model/template-creator';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class DataURLCommonService {
  ValueFrom = ValueFrom;
  callFrom: string = 'template';
  constructor(
    private fetchDataService: FetchDataService,
    private collectionEntryService: CollectionEntryService
  ) {}

  getValuesFromData(dataUrlInfo, option, item, key, isList: boolean = false) {
    if (isList) {
      if (!option['Value']) {
        option['Value'] = [];
      }
      if (dataUrlInfo.result.speratedBy && dataUrlInfo.result.speratedBy != '') {
        let values = item[key].split(dataUrlInfo.result.speratedBy);
        values.forEach((val) => {
          option['Value'].push(val);
        });
      } else {
        if (Array.isArray(item[key])) {
          option['Value'] = item[key];
        } else {
          option['Value'].push(item[key]);
        }
      }
    } else {
      option['Value'] = item[key];
    }
  }

  findValueInData(dataUrlInfo, option, resultPath, data, pathLength, currentPathIndex: number = 1) {
    data.forEach((item) => {
      if (currentPathIndex == pathLength - 1) {
        this.getValuesFromData(dataUrlInfo, option, item, resultPath[pathLength - 1], true);
      } else {
        this.findValueInData(
          dataUrlInfo,
          option,
          resultPath,
          item[resultPath[currentPathIndex + 1]],
          pathLength,
          currentPathIndex + 1
        );
      }
    });
  }

  bindDataToExcelGrid(attribute, object: any = {}) {
    if (attribute['excelGrid']) {
      if (attribute.DataUrlData.length) {
        // (i+1)+'. '+
        attribute['source'] = attribute.DataUrlData.map((val, i) => {
          return val.Label;
        });
        attribute['source'].unshift('');
      }
      if (attribute['callback']) {
        attribute['source'] = attribute[object.Title + '_fetch_data'].map((val, i) => {
          return i + 1 + '. ' + val.Label;
        });
        attribute['callback'](attribute['source']);
      }
    }
  }

  /** Get value from id..
   * @param {object} attribute- An object of blueprint collection or resource attribute.
   * @param {object} currentItem- An object of blueprint resource.
   * @param {boolean} isComplexLabel- Attribute is a complex type or not.
   * @param {string} attributeName- Name of attribute.
   */
  idsToLable(attribute, currentItem, isComplexLabel, attributeName){
    let label: any;
    if(isComplexLabel) {
        label = attribute.DataUrlData.find(dd => dd.Value == currentItem[attributeName]);
        if(label !== undefined)
            currentItem[attributeName] = label.Label;
    } else if(attribute.AttributeType.IsList) {
        currentItem?.Value?.forEach(value => {
            label = attribute.DataUrlData.find(dd => dd.Value == value.Value);
            if(label !== undefined)
                value[attributeName] = label.Label;
        });
    } else {
        label = attribute.DataUrlData.find(dd => dd.Value == attribute.Value);
        if(label !== undefined)
            currentItem[attributeName] = label.Label;
    }
  }

 getUseData(
    attribute, 
    isCollectionEntryAttributeId : boolean  = false, 
    isNeedLable: boolean = false,
    currentItem: any = {},
    isComplexLabel: boolean = false,
    attributeName: string = 'ddLable'
  ){
    attribute['loader'] = true;
    let id = isCollectionEntryAttributeId ? (attribute.CollectionEntryAttributeId || attribute.Id) : attribute.Id;
      this.collectionEntryService.GetAttributeData(id).subscribe(
        (result) => {
          attribute.DataUrlData = [];
          result.forEach((value) => {
            attribute.DataUrlData.push({ Label: value || 'N/A', Value: value });
          });
          attribute['loader'] = false;
          if(isNeedLable) {
              this.idsToLable(attribute, currentItem, isComplexLabel, attributeName);
          }
          this.bindDataToExcelGrid(attribute);
        },
        (error) => {
          attribute['loader'] = false;
        }
      );
  }

  parseDataUrl(
    attribute, 
    object,
    onNext: (value: string) => void,
    isNeedLable: boolean = false,
    currentItem: any = {},
    isComplexLabel: boolean = false,
    attributeName: string = 'ddLable'
  ){
    if(!object.DataUrl) {
        attribute.DataUrlData = [];
        let filter = {};
        let urls = JSON.parse(attribute.DataUrl);
        if(urls.length > 0) {
            let url = urls[0];
            filter[url.pagination_key?.filter || 'Filter'] = attribute['searchData'];
            filter[url.pagination_key?.page_number || 'PageNumber'] = 0;
            filter[url.pagination_key?.page_size || 'PageSize'] = 100;
            attribute[attribute.Name + '_fetch_data'] = [];
            attribute[attribute.Name + '_result_length'] = 0;
            attribute[attribute.Name + '_loader'] = false;
            object = {
                Attribute: attribute,
                DataUrl: url,
                PostFilter: filter,
                Title: attribute.Name
            }
            if(url.redirect_url) {
              attribute.RedirectUrl = url.redirect_url;
            }
        }
    }
    let dataUrlInfo = JSON.parse(JSON.stringify(object.DataUrl));
    if (dataUrlInfo.request_type == 'post') {
      let url = dataUrlInfo.url;
      let params = object.PostFilter;
      if (dataUrlInfo.parameters) {
        let keys = Object.keys(dataUrlInfo.parameters);
        keys.forEach((key) => {
          if (JSON.stringify(dataUrlInfo.parameters[key]).includes('{')) {
            //work in future
          } else {
            params[key] = dataUrlInfo.parameters[key];
          }
        });
      }
      if((currentItem && currentItem instanceof AbstractControl)) {
        if(currentItem?.get(attribute.Name)?.value) {
          if(!attribute.AttributeType?.IsList && !attribute.AttributeType?.IsComplex) {
            params['SelectedItemIds'] = [currentItem?.get(attribute.Name)?.value];
          } else if(attribute.AttributeType?.IsList){
            params['SelectedItemIds'] = currentItem?.get(attribute.Name)?.value;
          }
        } 
      }
      if(attribute.Value) {
        if(!attribute.AttributeType?.IsList && !attribute.AttributeType?.IsComplex) {
            params['SelectedItemIds'] = [attribute.Value];
        } else if(attribute.AttributeType?.IsList){
            let parsedValue = this.getValidJsonValue(attribute.Value, attribute.Name);
            params['SelectedItemIds'] = parsedValue[attribute.Name];
        }
      }
      attribute[object.Title + '_loader'] = true;
      attribute['loader'] = true;
      onNext('hit');
      this.fetchDataService.getPaginatedPostData(url, params).subscribe(
        (response) => {
          let data = [];
          let selectedItem = response.selectedItems || [];
          let items = [...response.items, ...selectedItem];
          items.forEach((item) => {
            let option = {};
            option['Id'] = item[dataUrlInfo.result.id];
            option['Label'] = item[dataUrlInfo.result.label];
            option['GroupBy'] = object.DataUrl.accordion_title;
            option['Type'] = item.Type;
            option['ItemDetail'] = item;
            let resultPath = dataUrlInfo.result.value.split('.');
            if (resultPath.length == 1) {
              this.getValuesFromData(
                dataUrlInfo,
                option,
                item,
                resultPath[0],
                attribute.IsList
              );
            } else {
              option['Value'] = [];
              let pathLength = resultPath.length;
              this.findValueInData(
                dataUrlInfo,
                option,
                resultPath,
                item[resultPath[0]],
                pathLength,
                1
              );
            }
            data.push(option);
          });
          attribute[object.Title + '_fetch_data'] = data;
          attribute[object.Title + '_result_length'] = response.totalCount;
          attribute[object.Title + '_loader'] = false;
          attribute['loader'] = false;
          attribute.DataUrlData = data;
          this.bindDataToExcelGrid(attribute, object);
          if (isNeedLable) {
            this.idsToLable(attribute, currentItem, isComplexLabel, attributeName);
          }
          onNext('fetch');
        },
        () => {
          attribute[object.Title + '_loader'] = false;
          attribute['loader'] = false;
          onNext('fetch');
        }
      );
    } else if (dataUrlInfo.request_type == 'get') {
      let url = dataUrlInfo.url;
      attribute[object.Title + '_loader'] = true;
      attribute['loader'] = true;
      onNext('hit');
      this.fetchDataService.getData(url).subscribe(
        (items) => {
          let data = [];
          items.forEach((item) => {
            let option = {};
            option['Id'] = item[dataUrlInfo.result.id];
            option['Label'] = item[dataUrlInfo.result.label];
            option['IsList'] = attribute.IsList;
            option['GroupBy'] = object.DataUrl.accordion_title;
            option['Type'] = item.Type;
            option['ItemDetail'] = item;
            let resultPath = dataUrlInfo.result.value.split('.');
            if (resultPath.length == 1) {
              this.getValuesFromData(
                dataUrlInfo,
                option,
                item,
                resultPath[0],
                attribute.IsList
              );
            } else {
              option['Value'] = [];
              let pathLength = resultPath.length;
              this.findValueInData(
                dataUrlInfo,
                option,
                resultPath,
                item[resultPath[0]],
                pathLength,
                1
              );
            }
            data.push(option);
          });
          attribute[object.Title + '_fetch_data'] = [
            ...attribute[object.Title + '_fetch_data'],
            ...data
          ];
          attribute[object.Title + '_loader'] = false;
          attribute['loader'] = false;
          attribute.DataUrlData = data;
          if (isNeedLable) {
            this.idsToLable(attribute, currentItem, isComplexLabel, attributeName);
          }
          attribute['source'] = attribute[object.Title + '_fetch_data'].map((val, i) => {
            return i + 1 + '. ' + val.Label;
          });
          onNext('fetch');
        },
        () => {
          attribute['loader'] = false;
          attribute[object.Title + '_loader'] = false;
          onNext('fetch');
        }
      );
    }
  }

  convertDataUrl(
    object: any,
    allCollections: any = [],
    mainForm: any = {},
    formIndex: number = 0,
    storeInvalidUrl: any[] = [],
    isFindValueInAllCollection: boolean = false,
    isEditTemplate: boolean = false,
    isNeedLable: boolean = false,
    currentItem: any = {},
    isComplexLabel: boolean = false,
    attributeName: string = 'ddLable',
  ) {
    let attribute = object.Attribute;
    let activeResourceId = object['ResourceId'];
    if (attribute.DataGeneratedBy != 'User') {
      return;
    }

    attribute.DataUrlData = [];
    if (attribute.UseData) {
      this.getUseData(attribute, false, isNeedLable, currentItem, isComplexLabel, attributeName);
      return;
    }
    if (attribute.DataUrl && attribute.DataUrl.length > 0) {
      if (this.isJSON(attribute.DataUrl)) {
        this.parseDataUrl(attribute, object, () => {});
      } else {
        let urlData = attribute.DataUrl.split(':')[1];
        const pattern = /{.+\w+}/;
        let isValidUrl = true;
        //this will show plus button besides of dropdown
        attribute.ShowAddButton = false;
        attribute['groupOptions'] = false;
        attribute['table'] = false;
        if (
          attribute.DataUrl.split(':')[0] == 'url' ||
          attribute.DataUrl.split(':')[0] == 'url+' ||
          attribute.DataUrl.split(':')[0] == 'url-table'
        ) {
          if (attribute.DataUrl.split(':')[0] == 'url+') {
            attribute.ShowAddButton = true;
          }
          if (attribute.DataUrl.split(':')[0] == 'url-table') {
            attribute['table'] = true;
          }

          if (pattern.test(urlData)) {
            const parameters = urlData.split('/').filter((m) => pattern.test(m));
            parameters.forEach((m) => {
              let parameterValue = m.replace('{', '').replace('}', '');
              let result = '';
              let attributeProperty = parameterValue.split('.');
              if (attributeProperty.length == 1) {
                if (object.Control !== undefined) {
                  let value = object.Control.value;
                  if (value) {
                    result = value[attributeProperty[0]];
                  }
                  if (!result) {
                    result = this.getParentAttributeValue(
                      object.parentValues,
                      attributeProperty[0]
                    );
                  }
                }
                if (object.isComplex && !result) {
                  let value = object.ComplexData;
                  result = value[attributeProperty[0]];
                }
                if (object.isCallFromVisibilty && !result) {
                  result = object.NewValue;
                }
              } else {
                const collectionName = attributeProperty[0];
                if (this.callFrom == 'template') {
                  mainForm.get('Wizard')?.value?.forEach((section) => {
                    section.Resources.forEach((resource) => {
                      let last_resource: any = Object.assign({}, resource);
                      for (var i = 1; i < attributeProperty.length; i++) {
                        if (
                          resource.TerraformResourceName == collectionName &&
                          last_resource[attributeProperty[i]] != undefined &&
                          last_resource[attributeProperty[i]] != ''
                        ) {
                          last_resource = last_resource[attributeProperty[i]];
                          if (i == attributeProperty.length - 1) {
                            result = last_resource;
                            break;
                          } else last_resource = last_resource[0];
                        }
                      }
                    });
                  });
                } else if (this.callFrom == 'workflow') {
                  mainForm.get('Resources').value.forEach((resource) => {
                    let last_resource: any = Object.assign({}, resource);
                    for (var i = 1; i < attributeProperty.length; i++) {
                      if (
                        resource.TerraformResourceName == collectionName &&
                        last_resource[attributeProperty[i]] != undefined &&
                        last_resource[attributeProperty[i]] != ''
                      ) {
                        last_resource = last_resource[attributeProperty[i]];
                        if (i == attributeProperty.length - 1) {
                          result = last_resource;
                          break;
                        } else last_resource = last_resource[0];
                      }
                    }
                  });
                }
              }

              if (!result || result.length === 0) {
                isValidUrl = false;
              }
              urlData = urlData.replace(m, result);
            });
          }

          // Store Dependent Url & Call again after fetching dependent value from resource template
          if (isEditTemplate && urlData && !isValidUrl) {
            storeInvalidUrl.push({ object: object });
          }

          if (urlData && isValidUrl) {
            attribute['loader'] = true;
            attribute['tableFilter'] = [];
            this.fetchDataService.getByUrl(urlData).subscribe(
              (response) => {
                attribute.DataUrlData = [];
                if (response) {
                  response.forEach((m, mi) => {
                    if (!(m instanceof Object)) {
                      attribute.DataUrlData.push({ Label: m || 'N/A', Value: m });
                    } else {
                      if (attribute['table']) {
                        if (mi == 0) {
                          attribute['DataUrlHeading'] = Object.keys(m);
                          const index = attribute['DataUrlHeading'].indexOf('Value');
                          if (index > -1) {
                            attribute['DataUrlHeading'].splice(index, 1);
                          }
                        }
                        m['isSelected'] = false;
                        if (
                          attribute.Value != null &&
                          attribute.Value != '' &&
                          m.Value == attribute.Value
                        )
                          m['isSelected'] = true;
                        attribute.DataUrlData.push(m);
                      } else
                        attribute.DataUrlData.push({
                          Label: m.Label || 'N/A',
                          Value: m.Value
                        });
                    }
                    attribute['tableFilter'] = attribute.DataUrlData;
                    this.bindDataToExcelGrid(attribute);
                  });
                }
                attribute['loader'] = false;
              },
              (error) => {
                attribute['loader'] = false;
              }
            );
          }
        } else if (attribute.DataUrl.split(':')[0] == 'diagram') {
          if (attribute.ValueFrom == this.ValueFrom.Blueprint) {
            this.getDataUrlDataFromBluePrint(attribute, urlData, activeResourceId, allCollections);
            // if(attribute.DataUrlData.length == 0) {
            this.getResourcesName(attribute, urlData, activeResourceId, mainForm);
            // }
          } else {
            if (urlData) {
              this.getResourcesName(attribute, urlData, activeResourceId, mainForm);
            }
            if(object['workflowWizardParams']) {
              if(attribute.groupOptions) {
                attribute.DataUrlData = [...attribute.DataUrlData, object['workflowWizardParams']];
              } else {
                attribute.groupOptions = true;
                let options = attribute.DataUrlData;
                attribute.DataUrlData = [];
                attribute.DataUrlData = [...[{Label: 'Resources', Value: options}], ...object['workflowWizardParams']];
              }
            }
          }
          // Check selected value is present or not
          let control = object.Control?.get(attribute.Name);
          if (control) {
            if (attribute.DataUrlData.length > 0) {
              if (
                attribute.DataUrlData.findIndex((data) => data.Value == control.value) < 0 &&
                attribute['groupOptions'] == false &&
                !attribute.AttributeType.IsList
              ) {
                control.setValue('');
              }
            } else {
              control.setValue('');
            }
          }
          this.bindDataToExcelGrid(attribute);
        } else if (attribute.DataUrl.split(':')[0] == 'label-dropdown') {
          let attributeProperty = urlData.split('.');
          const collectionName = attributeProperty[0];
          if (this.callFrom == 'template') {
            let wizard = mainForm.get('Wizard')['controls'];
            wizard = wizard?.filter((section) => section.get('IsVisible').value == true);
            if (wizard && wizard[formIndex]) {
              this.runValidation(wizard[formIndex]);
            }
            let val = Object.assign({}, mainForm.value);
            val.Wizard?.forEach((section) => {
              section.Resources.forEach((resource) => {
                let last_resource: any = Object.assign({}, resource);
                for (var i = 1; i < attributeProperty.length - 1; i++) {
                  if (
                    resource.TerraformResourceName == collectionName &&
                    last_resource[attributeProperty[i]] != undefined &&
                    last_resource[attributeProperty[i]] != ''
                  ) {
                    last_resource = last_resource[attributeProperty[i]];
                    if (i == attributeProperty.length - 2 && last_resource) {
                      last_resource.forEach((element) => {
                        let key_name = attributeProperty[attributeProperty.length - 1];
                        attribute.DataUrlData.push({
                          Label: element[key_name] || 'N/A',
                          Value: element[key_name]
                        });
                      });
                      return;
                    } else last_resource = last_resource[0];
                  }
                }
              });
            });
          } else if (this.callFrom == 'workflow') {
            this.runValidation(mainForm);
            let resources = mainForm.get('Resources')['controls'];
            resources.forEach((resource) => {
              let last_resource: any = Object.assign({}, resource);
              for (var i = 1; i < attributeProperty.length - 1; i++) {
                if (
                  resource.TerraformResourceName == collectionName &&
                  last_resource[attributeProperty[i]] != undefined &&
                  last_resource[attributeProperty[i]] != ''
                ) {
                  last_resource = last_resource[attributeProperty[i]];
                  if (i == attributeProperty.length - 2 && last_resource) {
                    last_resource.forEach((element) => {
                      let key_name = attributeProperty[attributeProperty.length - 1];
                      attribute.DataUrlData.push({
                        Label: element[key_name] || 'N/A',
                        Value: element[key_name]
                      });
                    });
                    return;
                  } else last_resource = last_resource[0];
                }
              }
            });
          }

          if (attribute.DataUrlData.length == 0 && isFindValueInAllCollection) {
            allCollections
              .filter((m) => !m.IsContainer)
              .forEach((c) => {
                if (c.CollectionAttributeValues) {
                  let data = c.CollectionAttributeValues.find(
                    (m) => m.Name == 'Terraform Resource Name' && m.Value == attributeProperty[0]
                  );
                  if (data) {
                    this.bindLabelDropdown(c, attributeProperty, attribute);
                  }
                }
              });
          }
          this.bindDataToExcelGrid(attribute);
        }
      }
    }
  }

  getParentAttributeValue(valueForm, propertyName) {
    let result: string = '';
    if (valueForm) {
      if (Object.keys(valueForm).length !== 0) {
        result = valueForm.value[propertyName];
        if (!result) {
          result = this.getParentAttributeValue(valueForm.parentValues, propertyName);
        }
      }
    }
    return result;
  }

  getDataUrlDataFromBluePrint(
    attribute,
    resourceNames,
    activeResourceId,
    allCollections: any = []
  ) {
    let terraformResourceNames = resourceNames.split(';');
    if (terraformResourceNames && terraformResourceNames.length > 1) {
      attribute['groupOptions'] = true;
      for (let i = 0; i < terraformResourceNames.length; i++) {
        let terraformResourceName = terraformResourceNames[i].split('.')[0];
        allCollections
          .filter(
            (m) =>
              m.ResourceName == resourceNames ||
              (m.CollectionAttributeValues != null &&
                m.CollectionAttributeValues.some(
                  (y) => y.Name == 'Terraform Resource Name' && y.Value == terraformResourceName
                ))
          )
          .forEach((c) => {
            if (c.BlueprintCollectionAttributes) {
              let data = c.BlueprintCollectionAttributes.find((m) => m.Name == 'name');
              if (!data) {
                data = c.BlueprintCollectionAttributes[0];
              }
              if (data) {
                let resourceName = c.CollectionAttributeValues.find(
                  (m) => m.Name.toLowerCase() == 'name'
                );
                let index = attribute.DataUrlData.findIndex((x) => x.Label == resourceName.Value);
                if (index == -1) {
                  attribute.DataUrlData.push({ Label: resourceName.Value || 'N/A', Value: [] });
                  index = attribute.DataUrlData.findIndex((x) => x.Label == resourceName.Value);
                }
                if (!this.isUniqueSelection(attribute, allCollections, c.Id, activeResourceId)) {
                  attribute.DataUrlData[index].Value.push({
                    Label: data.Value || 'N/A',
                    Value: c.Id
                  });
                }
              }
            }
          });
      }
    } else {
      let terraformResourceName = resourceNames.split('.')[0];
      allCollections
        .filter(
          (m) =>
            m.ResourceName == resourceNames ||
            (m.CollectionAttributeValues != null &&
              m.CollectionAttributeValues.some(
                (y) => y.Name == 'Terraform Resource Name' && y.Value == terraformResourceName
              ))
        )
        .forEach((c) => {
          if (c.BlueprintCollectionAttributes) {
            let data = c.BlueprintCollectionAttributes.find((m) => m.Name == 'name');
            if (!data) {
              data = c.BlueprintCollectionAttributes[0];
            }
            if (data) {
              if (attribute.DataUrlData.findIndex((x) => x.Value == c.Id) == -1) {
                let activeCollection = allCollections.find((x) => x.Id == activeResourceId);
                if (!this.isUniqueSelection(attribute, allCollections, c.Id, activeCollection)) {
                  attribute.DataUrlData.push({
                    Label: data.Value || 'N/A',
                    Value: c.Id
                  });
                }
              }
            }
          }
        });
    }
  }

  isUniqueSelection(attribute, allCollections, id, activeCollection) {
    let isAssociated: boolean = false;
    if (attribute.FunctionTags) {
      if (attribute.FunctionTags.findIndex((tag) => tag == 'UniqueSelection') > -1) {
        const droppedCollections = allCollections;
        let collections = droppedCollections.filter(
          (collection) =>
            !collection.IsContainer &&
            collection.Id != activeCollection.Id &&
            collection.ResourceId != activeCollection.Id &&
            collection.ResourceName == activeCollection.ResourceName
        );
        for (let i = 0; i < collections.length; i++) {
          let collection = collections[i];
          for (let j = 0; j < collection.CollectionEntryAttributes.length; j++) {
            let collectionEntryAttribute = collection.CollectionEntryAttributes[j];
            if (
              collectionEntryAttribute &&
              collectionEntryAttribute.Name == attribute.Name &&
              collectionEntryAttribute.Value
            ) {
              if (collectionEntryAttribute.Value.includes(id)) {
                isAssociated = true;
                break;
              }
            }
          }
          if (isAssociated) {
            isAssociated = true;
            break;
          }
        }
      }
    }
    return isAssociated;
  }

  getResourcesName(attribute, resourceNames, activeResourceId, mainForm: any = {}) {
    let val = Object.assign({}, mainForm.value);
    let terraformResourceNames = resourceNames.split(';');
    if (terraformResourceNames && terraformResourceNames.length > 1) {
      attribute['groupOptions'] = true;
      for (let i = 0; i < terraformResourceNames.length; i++) {
        // for multiple resource
        if (this.callFrom == 'template') {
          val.Wizard?.filter((m) =>
            m.Resources.filter(
              (y) => y.AllowMultiple && y.TerraformResourceName == terraformResourceNames[i]
            ).forEach((y, index) => {
              var label =
                y.name !== undefined && y.name !== ''
                  ? y.name
                  : y.ResourceName + ' ' + (index + 1).toString();
              let indexData = attribute.DataUrlData.findIndex((x) => x.Label == y.ResourceName);
              if (indexData == -1) {
                attribute.DataUrlData.push({ Label: y.ResourceName || 'N/A', Value: [] });
                indexData = attribute.DataUrlData.findIndex((x) => x.Label == y.ResourceName);
              }
              if (
                attribute.DataUrlData[indexData].Value.findIndex((x) => x.Value == y.ResourceId) ==
                -1
              ) {
                attribute.DataUrlData[indexData].Value.push({
                  Label: label || 'N/A',
                  Value: y.ResourceId
                });
              }
            })
          );
        } else if (this.callFrom == 'workflow') {
          val.Resources?.filter(
            (y) => y.AllowMultiple && y.TerraformResourceName == terraformResourceNames[i]
          ).forEach((y, index) => {
            var label =
              y.name !== undefined && y.name !== ''
                ? y.name
                : y.ResourceName + ' ' + (index + 1).toString();
            let indexData = attribute.DataUrlData.findIndex((x) => x.Label == y.ResourceName);
            if (indexData == -1) {
              attribute.DataUrlData.push({ Label: y.ResourceName || 'N/A', Value: [] });
              indexData = attribute.DataUrlData.findIndex((x) => x.Label == y.ResourceName);
            }
            if (
              attribute.DataUrlData[indexData].Value.findIndex((x) => x.Value == y.ResourceId) == -1
            ) {
              attribute.DataUrlData[indexData].Value.push({
                Label: label || 'N/A',
                Value: y.ResourceId
              });
            }
          });
        }

        // for single resource
        let parentIdsList: any[] = [];
        if (this.callFrom == 'template') {
          val.Wizard?.filter((m) => {
            var z = m.Resources.find(
              (y) =>
                y.AllowMultiple == false && y.TerraformResourceName == terraformResourceNames[i]
            );
            if (z) {
              var label = z.name !== undefined && z.name !== '' ? z.name : z.ResourceName;
              if (parentIdsList.findIndex((x) => x.Value == z.ResourceId) == -1) {
                parentIdsList.push({
                  Label: label || 'N/A',
                  Value: z.ResourceId,
                  ResourceName: z.ResourceName
                });
              }
            }
          });
        } else if (this.callFrom == 'workflow') {
          var z = val.Resources?.find(
            (y) => y.AllowMultiple == false && y.TerraformResourceName == terraformResourceNames[i]
          );
          if (z) {
            var label = z.name !== undefined && z.name !== '' ? z.name : z.ResourceName;
            if (parentIdsList.findIndex((x) => x.Value == z.ResourceId) == -1) {
              parentIdsList.push({
                Label: label || 'N/A',
                Value: z.ResourceId,
                ResourceName: z.ResourceName
              });
            }
          }
        }

        if (parentIdsList.length > 0) {
          let indexData = attribute.DataUrlData.findIndex(
            (x) => x.Label == parentIdsList[0].ResourceName
          );
          if (indexData == -1) {
            attribute.DataUrlData.push({ Label: parentIdsList[0].ResourceName || 'N/A', Value: [] });
            indexData = attribute.DataUrlData.findIndex(
              (x) => x.Label == parentIdsList[0].ResourceName
            );
          }
          attribute.DataUrlData[indexData].Value.push(parentIdsList[0]);
        }
      }
    } else {
      // for multiple resource
      let terraformResourceName = resourceNames.split('.')[0];
      if (this.callFrom == 'template') {
        val.Wizard?.filter((m) =>
          m.Resources.filter(
            (y) => y.AllowMultiple && y.TerraformResourceName == terraformResourceName
          ).forEach((y, index) => {
            var label =
              y.name !== undefined && y.name !== ''
                ? y.name
                : y.ResourceName + ' ' + (index + 1).toString();
            let dataIndex = attribute.DataUrlData.findIndex((x) => x.Value == y.ResourceId);
            if (dataIndex > -1) {
              attribute.DataUrlData.splice(dataIndex, 1);
            }
            attribute.DataUrlData.push({
              Label: label || 'N/A',
              Value: y.ResourceId
            });
          })
        );
      } else if (this.callFrom == 'workflow') {
        val.Resources?.filter(
          (y) => y.AllowMultiple && y.TerraformResourceName == terraformResourceName
        ).forEach((y, index) => {
          var label =
            y.name !== undefined && y.name !== ''
              ? y.name
              : y.ResourceName + ' ' + (index + 1).toString();
          let dataIndex = attribute.DataUrlData.findIndex((x) => x.Value == y.ResourceId);
          if (dataIndex > -1) {
            attribute.DataUrlData.splice(dataIndex, 1);
          }
          attribute.DataUrlData.push({
            Label: label || 'N/A',
            Value: y.ResourceId
          });
        });
      }
      // for single resource
      let parentIdsList: any[] = [];

      if (this.callFrom == 'template') {
        val.Wizard?.filter((m) => {
          var z = m.Resources.find(
            (y) => y.AllowMultiple == false && y.TerraformResourceName == terraformResourceName
          );
          if (z) {
            var label = z.name !== undefined && z.name !== '' ? z.name : z.ResourceName;
            if (parentIdsList.findIndex((x) => x.Value == z.ResourceId) == -1) {
              parentIdsList.push({
                Label: label || 'N/A',
                Value: z.ResourceId
              });
            }
          }
        });
      } else if (this.callFrom == 'workflow') {
        var z = val.Resources?.find(
          (y) => y.AllowMultiple == false && y.TerraformResourceName == terraformResourceName
        );
        if (z) {
          var label = z.name !== undefined && z.name !== '' ? z.name : z.ResourceName;
          if (parentIdsList.findIndex((x) => x.Value == z.ResourceId) == -1) {
            parentIdsList.push({
              Label: label || 'N/A',
              Value: z.ResourceId
            });
          }
        }
      }
      if (parentIdsList.length > 0) {
        let dataIndex = attribute.DataUrlData.findIndex((x) => x.Value == parentIdsList[0].Value);
        if (dataIndex > -1) {
          attribute.DataUrlData.splice(dataIndex, 1);
        }
        attribute.DataUrlData.push(parentIdsList[0]);
      }
    }
  }

  /** Loop through each attribute key to get last attribute value and push into attribute DataUrlData of a given resource.
   * @param {object} collection- An object of blueprint resource.
   * @param {Array} attributeKeys- List of attribute keys.
   * @param {object} attribute- An object of blueprint collection or resource attribute.
   */
  bindLabelDropdown(collection, attributeKeys, attribute) {
    attribute.ParentMissingMessage = ''; // Use this attribute for Empty options in dropdown
    let label = collection.CollectionEntryAttributes.find((m) => m.Name == attributeKeys[1]);
    if (label && label.Value) {
      if (attributeKeys.length > 2) {
        let last_resource: any = JSON.parse(label.Value);
        if (last_resource) {
          for (var i = 1; i < attributeKeys.length; i++) {
            if (
              last_resource[attributeKeys[i]] != undefined &&
              last_resource[attributeKeys[i]] != ''
            ) {
              last_resource = last_resource[attributeKeys[i]];
              if (i == attributeKeys.length - 1) {
                attribute.DataUrlData.push({
                  Label: last_resource || 'N/A',
                  Value: last_resource
                });
                break;
              } else last_resource = last_resource[0];
            }
          }
        }
      } else {
        attribute.DataUrlData.push({
          Label: label.Value || 'N/A',
          Value: label.Value
        });
      }
    } else {
      let resourceTerraformName = collection.CollectionAttributeValues.find(
        (x) => x.Name.toLowerCase() == 'terraform resource name'
      ).Value;
      attribute.ParentMissingMessage =
        'Please configure ' +
        (label ? label.DisplayName : attributeKeys[1]) +
        ' (' +
        resourceTerraformName +
        ')' +
        ' first before configuring this resource.';
    }
  }

  convertDataUrlCSP(attribute, mainForm, allCollection, resourceId) {
    let urlData = attribute.DataUrl.split(':')[1];
    attribute.DataUrlData = [];
    if (attribute.ValueFrom == this.ValueFrom.Blueprint) {
      if (attribute.DataUrl.split(':')[0] == 'diagram') {
        this.getDataUrlDataFromBluePrint(attribute, urlData, resourceId, allCollection);
        // if(attribute.DataUrlData.length == 0) {
        this.getResourcesName(attribute, urlData, resourceId, mainForm);
        // }
      } else {
        this.getDataUrlDataFromBluePrint(attribute, attribute.DataUrl, resourceId, allCollection);
        // if(attribute.DataUrlData.length == 0) {
        this.getResourcesName(attribute, attribute.DataUrl, resourceId, mainForm);
        // }
      }
    } else {
      this.runValidation(mainForm);
      if (urlData) {
        this.getResourcesName(attribute, urlData, resourceId, mainForm);
      } else {
        this.getResourcesName(attribute, attribute.DataUrl, resourceId, mainForm);
      }
    }
  }

  /** Returns valid json object.
   * @param {string} value - value that you want to parse.
   * @param {string} name - name of attribute.
   */
  getValidJsonValue(value, name) {
    let json: any = {};
    if (value) {
      try {
        if (Array.isArray(value)) {
          json[name] = value;
          return json;
        }
        json = JSON.parse(value);
        return json;
      } catch (e) {
        json[name] = [];
        return json;
      }
    } else {
      json[name] = [];
      return json;
    }
  }

  isJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  checkForNull(obj) {
    let valid = false;
    Object.keys(obj).forEach((prop) => {
      if (obj[prop] && obj[prop].length > 0) valid = true;
    });
    return valid;
  }

  runValidation(control: AbstractControl, isMarkaAsTouched: boolean = false) {
    if (control instanceof FormGroup) {
      const group = control as FormGroup;
      this.controlValidation(group, isMarkaAsTouched);
    } else if (control instanceof FormArray) {
      const group = control as FormArray;
      this.controlValidation(group, isMarkaAsTouched);
    }

    control?.updateValueAndValidity({ onlySelf: false, emitEvent: false });
  }

  controlValidation(group, isMarkaAsTouched: boolean = false) {
    for (const field in group.controls) {
      const c = group.controls[field];
      if (isMarkaAsTouched) {
        c.markAsTouched();
      }
      this.runValidation(c, isMarkaAsTouched);
    }
  }
}
